if(typeof HI == 'undefined') HI = {};
HI.config = {
  'wrapperID': 'HI-hotspotWrapper',
  'hotspotClass': 'HI-hotspot',
  'hotspotPrefix': 'HI-hotspot',
  'containerPrefix': 'HI-itemContainer',
  'overlayID': 'HI-infoContentOverlay'
};
HI.assets = {
  
};


HI.loadImages = function(){
  for(var i=0; i<HI.itemConfig.images.length; i++){
    HI.insertImage(HI.itemConfig.images[i]);
    HI.attachHotspots(HI.itemConfig.images[i]);
  }
}


HI.insertImage = function(imageConfig){
  var image = '<div style="display:none;" class="' + HI.config.containerPrefix + '" id="' + HI.config.containerPrefix + '_' + imageConfig['id'] +'">';
  image += '<img src="' + HI.pageImages[imageConfig['filename']] + '" width="100%" />';
  image += '</div>';
  HI.container.append(image);
}


HI.attachHotspots = function(imageConfig){
  for(var hotspotIdentifier in imageConfig.hotspots){
    var hotspot = imageConfig.hotspots[hotspotIdentifier];
    var hotspotId = HI.config.hotspotPrefix + '_' + imageConfig['id'] + '_' + hotspotIdentifier;
    var hotspotClass = HI.config.hotspotClass + ' ' + hotspot['icon'];
    var hotspotStyle = 'left:' + hotspot['left'] + '; top:' + hotspot['top'];
    var hotspotHTML = '<div id="'+ hotspotId +'" hotspotid="'+ hotspotIdentifier +'" class="'+ hotspotClass +'" style="'+ hotspotStyle +'"><div class="dot"></div><div class="pulse"></div></div>';
    $('#' + HI.config.containerPrefix + '_' + imageConfig['id']).append(hotspotHTML);
  }
}


HI.showImage = function(imageID){
  // hide all other images
  $('.' + HI.config.containerPrefix).hide().filter('#' + HI.config.containerPrefix + '_' + imageID).show();
}


HI.hotspotClick = function(hotspotEl){
  var config = HI.getItemConfigFromHotspotEl(hotspotEl);

  if(config.hotspotConfig.switchImage){
    // switch active image
    HI.showImage(config.hotspotConfig.switchImage); 
  }
}


HI.hotspotMouseover = function(hotspotEl){
  var config = HI.getItemConfigFromHotspotEl(hotspotEl);
  if(config.hotspotConfig.infoContent){
      // hide other info containers
      HI.hideInfoContent();
      // show info content
      HI.showInfoContent(hotspotEl);
    }
}


HI.showInfoContent = function(hotspotEl){
  var config = HI.getItemConfigFromHotspotEl(hotspotEl);
  var content = config.hotspotConfig.infoContent;

  // figure out positioning of the content box
  var hotspotPosition = hotspotEl.offset();
  var leftPos;
  var topPos;
  var contentPosition = (config.hotspotConfig['infoPosition'] ? config.hotspotConfig['infoPosition'] : 'right');
  if(contentPosition == 'right'){
    leftPos = parseInt(hotspotPosition.left) + 35;
    topPos = parseInt(hotspotPosition.top) - 15;
  }else if(contentPosition == 'left'){
    leftPos = parseInt(hotspotPosition.left) - 335;
    topPos = parseInt(hotspotPosition.top) - 15;
  }else if(contentPosition == 'bottom'){
    leftPos = parseInt(hotspotPosition.left) - 150;
    topPos = parseInt(hotspotPosition.top) + 35;
  }
  var overlayStyle = 'position:absolute; left:'+ leftPos +'px; top:'+ topPos +'px;';

  var html = '<div id="'+ HI.config.overlayID +'" style="'+ overlayStyle +'">';
  html    +=  content;
  html    += '</div>';

  $('body').append(html);
}


HI.hideInfoContent = function(){
  $('#' + HI.config.overlayID).remove();
}


HI.getItemConfigFromHotspotEl = function(hotspotEl){
  var imageConfig = false;
  var hatspotConfig = false;  
  for(var i=0; i<HI.itemConfig.images.length; i++){
    var imageConfig = HI.itemConfig.images[i];
    for(var hotspotIdentifier in imageConfig.hotspots){
      if(HI.config.hotspotPrefix + '_' + imageConfig.id + '_' + hotspotIdentifier == hotspotEl.attr('id')){
        hotspotConfig = imageConfig.hotspots[hotspotEl.attr('hotspotid')];
        return {'imageConfig':imageConfig, 'hotspotConfig':hotspotConfig };
      }
    }
  }
  return false;
}


HI.init = function(){
  HI.container = $('#' + HI.config.wrapperID);
  if(HI.container.length < 1) return;
  
  HI.loadImages();
  HI.showImage(HI.itemConfig.images[0].id);

  $('.' + HI.config.hotspotClass).on('click', function(){
    HI.hotspotClick($(this));
  });
  $('.' + HI.config.hotspotClass).on('mouseover', function(){
    HI.hotspotMouseover($(this));
  });
  $('.' + HI.config.hotspotClass).on('mouseleave', function(){
    HI.hideInfoContent();
  });
}




// Hotspot Image Script
$(document).ready(function(){
  HI.init();
});